<div class="iti-side-nav">
  <div class="iti-side-nav-item-header">
      <div
          class="user-info stretch"
          [matMenuTriggerFor]="menu"
      >
          <div class="user-name">{{ userInfo?.userName }}</div>
          <div>{{ userInfo?.category }}</div>
      </div>
      <button
          mat-icon-button
          [matMenuTriggerFor]="menu"
      >
          <mat-icon>expand_more</mat-icon>
      </button>
      <mat-menu
          #menu="matMenu"
          xPosition="before"
      >
          <button
              mat-menu-item
              (click)="changePassword()"
          >
              <mat-icon>vpn_key</mat-icon>
              <span>Change Password</span>
          </button>
          <button
              mat-menu-item
              (click)="logout()"
          >
              <mat-icon>power_settings_new</mat-icon>
              <span>Log out</span>
          </button>
      </mat-menu>
  </div>
  <ng-template ngFor let-item [ngForOf]="menuItems">
    <ng-template [ngIf]="!item.disabled">
        <div *accessCheck="item.name"
            class="iti-side-nav-item"
            [ngClass]="{ active: activeNavMain === item.activeTab }"
            (click)="onRoute(item.path)">
            <div class="iti-side-nav-item-highlight"></div>
            <div class="iti-side-nav-item-icon">
                <span class="material-icons">{{item.icon}}</span>
            </div>
            <div class="iti-side-nav-item-text">{{ item.displayName }}</div>
        </div>
    </ng-template>
</ng-template>
</div>
